import React from 'react';
import { IconAlert, IconZap, IconRefresh } from './Icons';
import './StateDisplays.css';

export function EmptyState({ 
  icon = '◌', 
  title = 'No Businesses Found', 
  description = 'Try changing your search keywords or clearing your filters to see more results.',
  onReset,
  resetLabel = 'Clear Filters'
}) {
  return (
    <div className="state-display-box empty-state">
      <span className="state-icon">{icon}</span>
      <h3 className="state-title">{title}</h3>
      <p className="state-desc">{description}</p>
      {onReset && (
        <button type="button" className="state-action-btn" onClick={onReset}>
          {resetLabel}
        </button>
      )}
    </div>
  );
}

export function ErrorState({ 
  title = 'Unable to Load Data', 
  message = 'Could not connect to the server. Please check your connection and try again.', 
  onRetry 
}) {
  return (
    <div className="state-display-box error-state">
      <span className="state-icon"><IconAlert width={24} height={24} style={{ color: '#ef4444' }} /></span>
      <h3 className="state-title">{title}</h3>
      <p className="state-desc">{message}</p>
      {onRetry && (
        <button type="button" className="state-action-btn retry-btn" onClick={onRetry}>
          <IconRefresh width={14} height={14} style={{ marginRight: '6px' }} />
          Try Again
        </button>
      )}
    </div>
  );
}

export function OfflineBanner() {
  return (
    <div className="offline-banner" role="alert">
      <span className="offline-icon"><IconZap width={14} height={14} style={{ color: '#f59e0b', marginRight: '6px' }} /></span>
      <span><strong>You Are Currently Offline</strong> — Showing saved business data until your connection returns.</span>
    </div>
  );
}
